import { Toast } from "flowbite-react";
import Dashboard from "../../common/components/layout/Dashboard";
import TableSuppliers from "./components/table-suppliers/TableSuppliers";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";

function SupplierRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableSuppliers />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default SupplierRegisterPage;